import { render, staticRenderFns } from "./NavigationItemPopover.vue?vue&type=template&id=035581b8"
import script from "./NavigationItemPopover.vue?vue&type=script&lang=js"
export * from "./NavigationItemPopover.vue?vue&type=script&lang=js"
import style0 from "./NavigationItemPopover.vue?vue&type=style&index=0&id=035581b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports